import {specialBodiesSlices} from '../../util/uiconstants';

export function getChildrenPropertyName(parentEntityId, parentEntityUId) {
	const prefix = parentEntityId ? `${parentEntityId}_${parentEntityUId}_` : '';
	return `${prefix}children`;
}

export const getBodyMetadataByBodyId = (state, bodyId) => {
	return state.bodiesSpecial.metadata[bodyId];
};

export const getSpecialBodySliceByEntityId = (state, entityId) => {
	let sliceName = specialBodiesSlices[entityId];

	return state.bodiesSpecial[sliceName];
};

export const getEntityDetailsById = (state, entityId, entityUId) => {
	const entitySlice = getSpecialBodySliceByEntityId(state, entityId);
	let entity;
	if (entitySlice) {
		entity = entitySlice.byId[entityUId];
	}

	return entity;
};

export const getEntityDetailsByIdList = (state, entitiesList, entityFilters, orderFunction) => {
	let entityDetailsList;
	if (entitiesList?.length > 0 && entitiesList.every((e) => e.entityId && e.entityUId)) {
		entityDetailsList = entitiesList.map((e) => getEntityDetailsById(state, e?.entityId, e?.entityUId));
	}

	// Apply entity-specific filters:
	let filteredEntityDetailsList;
	if (entityFilters && entityDetailsList?.length > 0) {
		filteredEntityDetailsList = [];
		for (const entity of entityDetailsList) {
			const filter = entityFilters[entity.entityId];
			if (filter && filter(entity)) {
				filteredEntityDetailsList.push(entity);
			} else {
				if (!filter) {
					filteredEntityDetailsList.push(entity);
				}
			}
		}
		entityDetailsList = filteredEntityDetailsList;
	}
	if (orderFunction) {
		entityDetailsList = orderFunction(entityDetailsList);
	}
	return entityDetailsList;
};
